import { render, staticRenderFns } from "./VatReverseCheckbox.vue?vue&type=template&id=798c0622"
import script from "./VatReverseCheckbox.vue?vue&type=script&lang=js"
export * from "./VatReverseCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports